const state = {
    user: window.user,
    team: window.team
}

// getters
const getters = {
    user: state => state.user,
    team: state => state.team,
}

// mutations
const mutations = {
  setUser(state, user) {
    state.user = user;
  },
  setTeam(state, team) {
    state.team = team;
  }
}

// actions
const actions = {
    fetchProfile({commit}) {
        axios.get('/api/account/user').then((response) => {
            commit('setUser', response.data);
            return response.data;
        }, (response) => {
            this.error = response;
        });
    },
    fetchTeam({commit}) {
        axios.get('/api/account').then((response) => {
            commit('setTeam', response.data);
            return response.data;
        }, (response) => {
            this.error = response;
        });
    }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}